export const STRATEGY_DASHBOARD_CHART_MARKET_QUERY_PARAM = "market";
export const STRATEGY_DASHBOARD_TABLE_MARKET_FILTER_KEY = "market";

export function buildStrategyBenchmarkChartMarketQuery(market) {
  if (!market) {
    return "";
  }

  return `&market=${encodeURIComponent(market)}`;
}

export function getStrategyDashboardChartMarkets(dashboard) {
  const markets = dashboard?.chartMarkets;

  if (!Array.isArray(markets) || markets.length === 0) {
    return null;
  }

  return markets.map(market => String(market).toUpperCase());
}

export function matchStrategyDashboardChartMarket(markets, marketFromUrl) {
  if (!Array.isArray(markets) || markets.length === 0 || !marketFromUrl) {
    return null;
  }

  const normalizedFromUrl = String(marketFromUrl).toUpperCase();

  if (!markets.includes(normalizedFromUrl)) {
    return null;
  }

  return normalizedFromUrl;
}

export function resolveStrategyDashboardChartMarket(markets, marketFromUrl) {
  if (!Array.isArray(markets) || markets.length === 0) {
    return null;
  }

  return (
    matchStrategyDashboardChartMarket(markets, marketFromUrl) || markets[0]
  );
}

/**
 *
 * @returns {{ search: { market: string } } | null}
 */
export function getStrategyDashboardChartMarketTableFilters(
  markets,
  marketFromUrl
) {
  const market = matchStrategyDashboardChartMarket(markets, marketFromUrl);

  if (!market) {
    return null;
  }

  return {
    search: { [STRATEGY_DASHBOARD_TABLE_MARKET_FILTER_KEY]: market }
  };
}

export function mergeStrategyDashboardTableDefaultSettings(
  defaultSettings = {},
  marketSettings
) {
  if (!marketSettings) {
    return defaultSettings;
  }

  const nextSettings = { ...defaultSettings };

  if (marketSettings.search) {
    nextSettings.search = {
      ...(defaultSettings.search || {}),
      ...marketSettings.search
    };
  }

  if (marketSettings.filters) {
    nextSettings.filters = {
      ...(defaultSettings.filters || {}),
      ...marketSettings.filters
    };
  }

  return nextSettings;
}
